module.exports = __webpack_public_path__ + "static/media/Group 649.7a0387b0.svg";